var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "LBL0010201" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            !_vm.isApprDisabled && _vm.showApproval
                              ? _c("c-appr-btn", {
                                  ref: "appr-btn",
                                  attrs: {
                                    name: "danger-journal-appr-btn",
                                    editable: _vm.editable,
                                    approvalInfo: _vm.approvalInfo,
                                  },
                                  on: {
                                    beforeApprAction: _vm.saveDataAppr,
                                    callbackApprAction: _vm.approvalCallback,
                                    requestAfterAction: _vm.getDetail,
                                  },
                                })
                              : _vm._e(),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    !_vm.disabled &&
                                    !Boolean(_vm.data.sysApprovalRequestId2),
                                  expression:
                                    "editable && !disabled && !Boolean(data.sysApprovalRequestId2)",
                                },
                              ],
                              attrs: {
                                url: _vm.saveUrl,
                                isSubmit: _vm.isSave,
                                param: _vm.data,
                                mappingType: _vm.mappingType,
                                label: "LBLSAVE",
                                icon: "save",
                              },
                              on: {
                                beforeAction: _vm.saveData,
                                btnCallback: _vm.saveCallback,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              required: "",
                              editable: _vm.editable,
                              disabled: true,
                              label: "LBL0010198",
                              name: "proceedingsTitle",
                            },
                            model: {
                              value: _vm.data.proceedingsTitle,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "proceedingsTitle", $$v)
                              },
                              expression: "data.proceedingsTitle",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                        },
                        [
                          _c("c-datepicker", {
                            attrs: {
                              required: "",
                              editable: _vm.editable,
                              disabled: true,
                              label: "LBL0010199",
                              name: "proceedingsDate",
                            },
                            model: {
                              value: _vm.data.proceedingsDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "proceedingsDate", $$v)
                              },
                              expression: "data.proceedingsDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                        },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: "",
                              editable: _vm.editable,
                              disabled: true,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                        },
                        [
                          _c("c-dept", {
                            attrs: {
                              required: true,
                              disabled: true,
                              editable: _vm.editable,
                              label: "작성부서",
                              name: "deptCd",
                            },
                            model: {
                              value: _vm.data.deptCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deptCd", $$v)
                              },
                              expression: "data.deptCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                        },
                        [
                          _c("c-textarea", {
                            attrs: {
                              editable: _vm.editable,
                              disabled: _vm.disabled,
                              rows: 2,
                              label: "LBL0010202",
                              name: "proceedingsContents",
                            },
                            model: {
                              value: _vm.data.proceedingsContents,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "proceedingsContents", $$v)
                              },
                              expression: "data.proceedingsContents",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-table", {
                  ref: "inTable",
                  attrs: {
                    title: "회사측 참석자 목록",
                    columns: _vm.inGrid.columns,
                    gridHeight: _vm.gridHeight,
                    data: _vm.data.attendeeCoModels,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    hideBottom: true,
                    editable: _vm.editable && !_vm.disabled,
                    checkClickFlag: false,
                    isExcelDown: false,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "click"
                            ? [
                                props.row.attendeeSignatureFlag == "Y"
                                  ? _c(
                                      "q-btn",
                                      {
                                        attrs: {
                                          round: "",
                                          unelevated: "",
                                          size: "10px",
                                          color: "amber",
                                          icon: "search",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return (() => {
                                              ;(_vm.rowIndex = props.rowIndex),
                                                (_vm.electronSignature =
                                                  props.row.electronSignature)
                                            }).apply(null, arguments)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "q-popup-proxy",
                                          {
                                            ref: "proxy1_" + props.rowIndex,
                                            attrs: { breakpoint: 400 },
                                          },
                                          [
                                            _c(col.component, {
                                              tag: "component",
                                              attrs: {
                                                popupParam: props.row,
                                                rowIndex: props.rowIndex,
                                              },
                                              on: { callback: _vm.callback1 },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-table", {
                  ref: "outTable",
                  attrs: {
                    title: "근로자측 참석자 목록",
                    columns: _vm.inGrid.columns,
                    gridHeight: _vm.gridHeight,
                    data: _vm.data.attendeeEmpModels,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    hideBottom: true,
                    checkClickFlag: false,
                    isExcelDown: false,
                    editable: _vm.editable && !_vm.disabled,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "click"
                            ? [
                                props.row.attendeeSignatureFlag == "Y"
                                  ? _c(
                                      "q-btn",
                                      {
                                        attrs: {
                                          round: "",
                                          unelevated: "",
                                          size: "10px",
                                          color: "amber",
                                          icon: "search",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return (() => {
                                              ;(_vm.rowIndex = props.rowIndex),
                                                (_vm.electronSignature =
                                                  props.row.electronSignature)
                                            }).apply(null, arguments)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "q-popup-proxy",
                                          {
                                            ref: "proxy2_" + props.rowIndex,
                                            attrs: { breakpoint: 400 },
                                          },
                                          [
                                            _c(col.component, {
                                              tag: "component",
                                              attrs: {
                                                popupParam: props.row,
                                                rowIndex: props.rowIndex,
                                              },
                                              on: { callback: _vm.callback2 },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c("c-table", {
                  ref: "table",
                  attrs: {
                    title: "회의 결과",
                    columns: _vm.grid2.columns,
                    data: _vm.data.opinionresult,
                    gridHeight: _vm.gridHeight,
                    merge: _vm.grid2.merge,
                    editable: _vm.editable && !_vm.disabled,
                    columnSetting: false,
                    isFullScreen: false,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "첨부파일" },
                  },
                  [
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                          staticStyle: { height: "280px" },
                        },
                        [
                          _c("c-upload", {
                            attrs: {
                              attachInfo: _vm.attachInfo,
                              editable: _vm.editable && !_vm.disabled,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }